import { LlmTextBlock, useLlm } from '@websolutespa/bom-mixer-llm';
import { Badge } from '../../components/Badge/badge';
import { MessageHead } from '../../components/MessageHead/message-head';
import style from './user-message.module.scss';

export type UserMessageProps = LlmTextBlock<'user'>;

export const UserMessage: React.FC<UserMessageProps> = (props) => {
  const systemContext = useLlm(state => state.systemContext);
  const { text } = props;
  return (
    <div className={style.row}>
      <div className={style.left}>
        <Badge mode="user" url={systemContext.avatarUrl} title={systemContext.userName} />
      </div>
      <div className={style.message}>
        <MessageHead name="You" />
        <h2 className={style.text} dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );
};

